export default __webpack_public_path__ + "static/media/image-best-gear.28ded79e.jpg";